module.exports = __webpack_public_path__ + "img/logo-foot.d0305985.png";